import noop from 'lodash/noop'
import { useNavigate } from 'react-router-dom'
import { classNames } from 'utils'

interface Props {
  children: React.ReactNode
  href?: string
  onClick?(): void
  className?: string
}

export default function TextLink({
  href,
  children,
  className = '',
  onClick = noop,
}: Props) {
  const navigate = useNavigate()
  const isInternal = href && href.startsWith('/')

  const handleClick = () => {
    if (isInternal) {
      navigate(href)
    } else {
      if (href) {
        window.open(href, '_blank', 'noopener,noreferrer')
      } else if (onClick) {
        onClick()
      }
    }
  }

  return (
    <div
      className={classNames(
        'inline cursor-pointer whitespace-nowrap text-[0.88rem] underline hover:text-black/60',
        className
      )}
      onClick={handleClick}
    >
      {children}
    </div>
  )
}
